import { createContext, Dispatch, SetStateAction, useContext } from "react";
import { SavedFiltersActions } from "./SavedFiltersActions";
import { FilterActions } from "./FilterActions";
import { FilterModes } from "./FilterContext";

export interface FilterDispatch {
  filterDispatcher: Dispatch<FilterActions>;
  setFilterMode: Dispatch<SetStateAction<FilterModes>>;
  savedFiltersDispatcher: Dispatch<SavedFiltersActions>;
}

export const FilterDispatchContext = createContext<FilterDispatch | undefined>(
  undefined,
);

export const useFilterDispatchContext = () => {
  const context = useContext(FilterDispatchContext);
  if (!context) {
    throw "useFilterDispatchContext() invoked without a parent provider";
  }
  return context;
};
